import React from 'react'
import { Descriptions } from 'antd';
import moment from 'moment';

export default function commonShowComponent(props) {
  const { result } = props;
  return (
    <div className='result-summary'>
        <div className='summary-label'>基本信息</div>
        <div className='summary-content'>
          <Descriptions column={2}>
            <Descriptions.Item label='整体评估结果'>{result.overallOutcomeAssessment}</Descriptions.Item>
            <Descriptions.Item label='日期和时间'>{result.documentDate&&moment(result.documentDate).format('YYYY-MM-DD')}</Descriptions.Item>
            <Descriptions.Item label='次数'>{result.count}</Descriptions.Item>
            <Descriptions.Item label='总次数'>{result.totalCount}</Descriptions.Item>
          </Descriptions>
        </div>
        <div className='summary-label'>记录信息</div>
        <div className='summary-content'>
          <Descriptions column={1}>
            <Descriptions.Item label='阶段目标'>{result.stageGoal}</Descriptions.Item>
            <Descriptions.Item label='本次目标'>{result.thisTimeGoal}</Descriptions.Item>
            <Descriptions.Item label='内容记录'>{result.content}</Descriptions.Item>
            <Descriptions.Item label='特别事件'>{result.specialEvent}</Descriptions.Item>
            <Descriptions.Item label='完成情况'>{result.completion}</Descriptions.Item>
            <Descriptions.Item label='问题困扰'>{result.problems}</Descriptions.Item>
            <Descriptions.Item label='来访反馈'>{result.visitTheFeedback}</Descriptions.Item>
            <Descriptions.Item label='收获成长'>{result.harvestAndGrow}</Descriptions.Item>
            <Descriptions.Item label='预留作业'>{result.reservedHomework}</Descriptions.Item>
            <Descriptions.Item label='其他情况补充'>{result.otherSituations}</Descriptions.Item>
          </Descriptions>
        </div>
       
      </div>
  )
}
